<h1 translate
    matDialogTitle>
    transaction_reviewer_modal_assign_reviewer
</h1>

<form (submit)="onSubmit()">
    <mat-dialog-content>
        <ui-suggest #suggestComponent
                    [searchSourceFactory]="suggestReviewers"
                    [value]="[reviewer]"
                    [defaultValue]="'transaction_reviewer_modal_none' | translate"
                    [placeholder]="'transaction_reviewer_modal_reviewer' | translate"
                    [maxLength]="64"
                    [displayCount]="5"
                    width="100%">
        </ui-suggest>
    </mat-dialog-content>

    <mat-dialog-actions *ngLet="{
                        loading: loading$ | async
                    } as state"
                        align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>
        <button [spinnerButtonLoading]="state.loading"
                [disabled]="state.loading"
                ui-spinner-button
                mat-flat-button
                type="submit"
                color="primary">
            {{ 'transaction_reviewer_modal_action_assign' | translate }}
        </button>
    </mat-dialog-actions>
</form>
